import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Bento } from "@/components/landing/Bento";
import { Catalog } from "@/components/landing/Catalog";
import { RiskCTA } from "@/components/landing/RiskCTA";

export default function Landing() {
  return (
    <main className="overflow-x-clip" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Bento />
      <Catalog />
      <RiskCTA />
    </main>
  );
}
